import { shuffle } from 'lodash/fp';
import { useMemo, useState } from 'react';
import image from '../../../../../page/screens/registerPage/onboarding-survey-step-two-highlight.png';
import authorImage from '../../../../../page/screens/registerPage/tomorrow-farms-portrait.jpg';
import api from '../../../../api';
import { Form } from '../../../components/Form';
import { FormErrorMessage } from '../../../components/Form/FormErrorMessage';
import {
    PanelRadioButtonGroup,
    PanelRadioButtonItem,
    PanelRadioButtonLabel,
} from '../../../components/PanelRadioButtonGroup';
import RegisterFlowTemplate from '../../../components/RegisterFlowTemplate';
import SaveButton from '../../../components/SaveButton';
import { goToOnboardingSurveyInterestStep } from '../../../services/GoTo';
import styles from '../styles.m.less';

const BUTTON_LABELS = {
    DISABLED: 'Continue',
    ENABLED: 'Continue',
};

const ORIGINS: string[] = [
    'Search engine (Google/Bing)',
    'LinkedIn',
    'AI search (ChatGPT, Perplexity, etc.)',
    'G2 Reviews',
    'Select Software Review',
    'Someone referred me',
    'I have used Small Improvements before',
    'HRIS integration',
];

function OnboardingSurveyOrigin() {
    const shuffledOrigins = useMemo(() => shuffle(ORIGINS), []);
    const [selectedOrigin, setSelectedOrigin] = useState<string | null>(null);

    const handleSubmit = async () => {
        if (selectedOrigin) {
            return api.onboardingSettings
                .updateOnboardingSettings({ origin: selectedOrigin })
                .then(goToOnboardingSurveyInterestStep)
                .catch(goToOnboardingSurveyInterestStep);
        }
    };

    return (
        <RegisterFlowTemplate
            step="3"
            imageURL={image}
            quote="“Instilling a culture of feedback early on is crucial because it helps to establish trust and accountability from day one.”"
            author="Eden Seiferheld"
            role="People & Operations, Tomorrow Farms"
            authorImage={authorImage}
            title="Where did you first hear about us?"
        >
            <Form<String> onSubmit={handleSubmit}>
                {({ submitError }) => {
                    return (
                        <div className={styles.signUpIn}>
                            <PanelRadioButtonGroup>
                                {shuffledOrigins.map(option => {
                                    return (
                                        <PanelRadioButtonItem
                                            key={option}
                                            selected={selectedOrigin === option}
                                            onSelect={() => setSelectedOrigin(option)}
                                            className={styles.radioButtonItem}
                                        >
                                            <PanelRadioButtonLabel>{option}</PanelRadioButtonLabel>
                                        </PanelRadioButtonItem>
                                    );
                                })}
                                <PanelRadioButtonItem
                                    key={'Other'}
                                    selected={selectedOrigin === 'Other'}
                                    onSelect={() => setSelectedOrigin('Other')}
                                    className={styles.radioButtonItem}
                                >
                                    <PanelRadioButtonLabel>Other</PanelRadioButtonLabel>
                                </PanelRadioButtonItem>
                            </PanelRadioButtonGroup>
                            <div className={styles.formButtonContainer}>
                                <SaveButton state={'ENABLED'} labels={BUTTON_LABELS} disabled={!selectedOrigin} />
                                {submitError ? <FormErrorMessage errorMessage={submitError} /> : null}
                            </div>
                        </div>
                    );
                }}
            </Form>
        </RegisterFlowTemplate>
    );
}

export default OnboardingSurveyOrigin;
